import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { country_code_list } from './Functions';
import { getApiBaseUrl } from '../../utils/utils';
import '../../entity-forms.css';

const CITIES = ['Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah','Fujairah','Umm Al Quwain'];
const HB_TYPES = [
  { value: '1', label: 'Warehouse' },
  { value: '2', label: 'Hub' },
  { value: '3', label: 'Spoke' },
];

export default function PartnerHomebase() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [partners, setPartners]     = useState([]);
  const [search, setSearch]         = useState('');

  const initForm = { user: sessionStorage.getItem('userid') };
  const [form, setForm]             = useState(initForm);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); loadPartners(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/partner-warehouse`);
      if (res.data?.data) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadPartners = async () => {
    try {
      const base = getApiBaseUrl();
      const res = await axios.get(`${base}/v1.0/partner/retrieve_list?page=0`);
      if (res.data?.data) setPartners(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setSelectedPartner(''); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setSelectedPartner(String(row.partnerId||'')); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); setSelectedPartner(''); };

  const validate = () => {
    if (!form.name || !form.type || !selectedPartner || !form.place || !form.address ||
        !form.locality || !form.city || !form.contactPerson || !form.lat || !form.lng) {
      setMsg('Please fill all required fields (*)'); return false;
    }
    setMsg(''); return true;
  };

  const buildPayload = () => ({
    name:        form.name,
    type:        form.type,
    partnerId:   parseInt(selectedPartner, 10),
    place:       form.place,
    address:     form.address,
    locality:    form.locality,
    city:        form.city,
    state:       form.city,
    country:     form.country || 'UAE',
    lat:         form.lat,
    lng:         form.lng,
    active:      true,
    contactPerson: form.contactPerson,
    updatedBy:   parseInt(sessionStorage.getItem('userid'), 10),
  });

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const payload = buildPayload();
      if (isEdit) payload.id = form.id;
      const res = await axios.post(`${API_URL}shypvdriverapp/partner-warehouse`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} warehouse(s)?`)) return;
    try {
      for (const item of selectedIds) {
        await axios.delete(`${API_URL}shypvdriverapp/partner-warehouse/${item.partnerId}/${item.id}`);
      }
      setSelectedIds([]); loadList();
    } catch { setErrMsg('Error deleting warehouse'); }
  };

  const toggleSelect = (id, row) => {
    const key = { id: row.id, partnerId: row.partnerId };
    setSelectedIds(prev => {
      const exists = prev.some(x => x.id === id);
      if (exists) { const next = prev.filter(x => x.id !== id); if (!next.length) setForm(initForm); return next; }
      setForm(row); setSelectedPartner(String(row.partnerId||'')); return [...prev, key];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.name?.toLowerCase().includes(search.toLowerCase()) ||
    String(r.id).includes(search)
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search warehouses…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Warehouse</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="partner-warehouses.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => ({ id:r.id, partnerId:r.partnerId })) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['ID','Name','Type','Partner','City','Contact','Lat','Lng','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading warehouses…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No warehouses found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.some(x => x.id === row.id);
              const partnerName = partners.find(p => String(p.pid)===String(row.partnerId))?.pname || row.partnerId;
              return (
                <tr key={row.id} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.id, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.id}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.name}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.type}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{partnerName}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.city}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.contactPerson}</td>
                  <td className="em-td" style={{ fontSize:11 }}>{row.lat}</td>
                  <td className="em-td" style={{ fontSize:11 }}>{row.lng}</td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} warehouse{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-archive" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Warehouse' : 'Add New Warehouse'}</p>
                    <p className="em-drawer-sub">{isEdit ? `ID: ${form.id}` : 'Fill in the warehouse details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Warehouse Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.name||''} placeholder="e.g. DXB Warehouse 1"
                    onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Type<span className="em-req">*</span></label>
                  <select className="em-field" value={form.type||''} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}>
                    <option value="">— Select type —</option>
                    {HB_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Partner<span className="em-req">*</span></label>
                  <select className="em-field" value={selectedPartner} onChange={e => setSelectedPartner(e.target.value)}>
                    <option value="">— Select partner —</option>
                    {partners.map(p => <option key={p.pid} value={p.pid}>{p.pname}</option>)}
                    {!partners.length && <option disabled>Loading partners…</option>}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Contact Person<span className="em-req">*</span></label>
                  <input className="em-field" value={form.contactPerson||''} placeholder="e.g. John Doe"
                    onChange={e => setForm(p => ({ ...p, contactPerson: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row">
                <label className="em-label">Place Name<span className="em-req">*</span></label>
                <input className="em-field" value={form.place||''} placeholder="e.g. Al Quoz Industrial"
                  onChange={e => setForm(p => ({ ...p, place: e.target.value }))} />
              </div>
              <div className="em-form-row">
                <label className="em-label">Address<span className="em-req">*</span></label>
                <input className="em-field" value={form.address||''} placeholder="Full address"
                  onChange={e => setForm(p => ({ ...p, address: e.target.value }))} />
              </div>
              <div className="em-form-row">
                <label className="em-label">Locality<span className="em-req">*</span></label>
                <input className="em-field" value={form.locality||''} placeholder="Locality / Area"
                  onChange={e => setForm(p => ({ ...p, locality: e.target.value }))} />
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">City<span className="em-req">*</span></label>
                  <select className="em-field" value={form.city||''} onChange={e => setForm(p => ({ ...p, city: e.target.value }))}>
                    <option value="">— Select city —</option>
                    {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Country</label>
                  <select className="em-field" value={form.country||'AE'} onChange={e => setForm(p => ({ ...p, country: e.target.value }))}>
                    {Object.entries(country_code_list()).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Latitude<span className="em-req">*</span></label>
                  <input className="em-field" value={form.lat||''} placeholder="25.2048"
                    onChange={e => setForm(p => ({ ...p, lat: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Longitude<span className="em-req">*</span></label>
                  <input className="em-field" value={form.lng||''} placeholder="55.2708"
                    onChange={e => setForm(p => ({ ...p, lng: e.target.value }))} />
                </div>
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Warehouse':'Save Warehouse'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
